import { render, staticRenderFns } from "./CustomerTurnoverAllocation.vue?vue&type=template&id=2b683098&scoped=true&"
import script from "./CustomerTurnoverAllocation.vue?vue&type=script&lang=js&"
export * from "./CustomerTurnoverAllocation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTurnoverAllocation.vue?vue&type=style&index=0&id=2b683098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b683098",
  null
  
)

export default component.exports